import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { safeStorage } from "~/shared/utils/safeStorage";

export interface NavigationStoreState {
  sidebarOpen: boolean;
  openSidebar: () => void;
  closeSidebar: () => void;
}

export const useNavigationStore = create<NavigationStoreState>()(
  persist(
    (set) => ({
      sidebarOpen: false,

      openSidebar: () => {
        set(() => ({
          sidebarOpen: true,
        }));
      },

      closeSidebar: () => {
        set(() => ({
          sidebarOpen: false,
        }));
      },
    }),
    {
      name: "navigationStore",
      version: 1,
      storage: createJSONStorage(() => safeStorage),
    },
  ),
);
